goog.provide("shadow.js.shim.module$$mui$material$Grow");
goog.provide("module$shadow_js_shim_module$$mui$material$Grow");
shadow.js.shim.module$$mui$material$Grow = shadow.js.nativeProvides["@mui/material/Grow"] = shadow$bridge("@mui/material/Grow");
module$shadow_js_shim_module$$mui$material$Grow.default = shadow.js.shim.module$$mui$material$Grow;
